var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('ul',_vm._l((this.data),function(el){return _c('li',[_c('a',{attrs:{"href":("#" + (_vm.toSlug(el.name)))}},[_vm._v(_vm._s(el.name))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }